import { useSelector } from 'react-redux';
import type Experiments from '@alltrails/core/types/Experiments';

export default function useExperiments() {
  return useSelector((state: { experiments: Experiments }) => state.experiments || {});
}
